import { ReactNode, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Intro.module.css';
import { Link } from 'react-router-dom';

import { apiSlice } from '../../services/api';
import useModal from '../../hooks/useModal';

import logo from '../../assets/landing/landing_logo.png';
import footer_logo from '../../assets/images/logo/selpub_cloud.svg';
import section_01 from '../../assets/landing/landing_setion_01.png';
import section_02 from '../../assets/landing/landing_setion_02.png';
import section_03 from '../../assets/landing/landing_setion_03.png';
import section_04 from '../../assets/landing/landing_setion_04.png';
import section_05 from '../../assets/landing/landing_setion_05.png';
import section_06 from '../../assets/landing/landing_setion_06.png';
import section_07 from '../../assets/landing/landing_setion_07.png';
import section_08 from '../../assets/landing/landing_setion_08.png';
import slide_01 from '../../assets/landing/landing_setion_08_slide_01.png';
import slide_02 from '../../assets/landing/landing_setion_08_slide_02.png';
import slide_03 from '../../assets/landing/landing_setion_08_slide_03.png';
import slide_04 from '../../assets/landing/landing_setion_08_slide_04.png';
import m_footer_logo from '../../assets/landing/landing_logo.png';
import m_section_01 from '../../assets/landing/m_landing_setion_01.png';
import m_section_02 from '../../assets/landing/m_landing_setion_02.png';
import m_section_03 from '../../assets/landing/m_landing_setion_03.png';
import m_section_04 from '../../assets/landing/m_landing_setion_04.png';
import m_section_05 from '../../assets/landing/m_landing_setion_05.png';
import m_section_06 from '../../assets/landing/m_landing_setion_06.png';
import m_section_07 from '../../assets/landing/m_landing_setion_07.png';
import m_section_08 from '../../assets/landing/m_landing_setion_08.png';
import m_slide_01 from '../../assets/landing/m_landing_setion_08_slide_01.png';
import m_slide_02 from '../../assets/landing/m_landing_setion_08_slide_02.png';
import m_slide_03 from '../../assets/landing/m_landing_setion_08_slide_03.png';
import m_slide_04 from '../../assets/landing/m_landing_setion_08_slide_04.png';

import {
  ADDRESS,
  BUSINESS_REGISTRATION_NUMBER,
  CEO,
  COPYRIGHT,
  COPYRIGHT_DESC,
  FOOTER_LINK,
  LOGIN,
  PRIVACY_POLICY,
  SELPUB_CLOUD,
  SELPUB_CREATOR,
  SELPUB_VIEWER,
  SERVICE_GUIDE,
  SERVICE_INTRODUCTION,
  TERMS,
} from '../../constants';
import { VITE_URL, isMobile } from '../../utils/util';

export default function Intro() {
  const cx = classNames.bind(styles);
  const [getTerms] = apiSlice.useLazyGetTermsQuery();
  const scrollToRef = useRef<(HTMLImageElement | null)[]>([]);
  const { toggleModal } = useModal();

  const loginUrl = `${VITE_URL}/login`;

  const navList = [
    SERVICE_INTRODUCTION,
    SELPUB_CLOUD,
    SELPUB_CREATOR,
    SELPUB_VIEWER,
    SERVICE_GUIDE,
  ];
  const sectionImgList = [
    section_02,
    section_03,
    section_04,
    section_05,
    section_06,
    section_07,
    section_08,
  ];
  const mobileSectionImgList = [
    m_section_02,
    m_section_03,
    m_section_04,
    m_section_05,
    m_section_06,
    m_section_07,
    m_section_08,
  ];
  const slideImgList = [slide_01, slide_02, slide_03, slide_04];
  const mobileSlideImgList = [m_slide_01, m_slide_02, m_slide_03, m_slide_04];

  const openModal = async (name: string) => {
    const agreeCd = name === 'terms' ? 'T0101' : 'T0102';
    const termsData = await getTerms(agreeCd, true).unwrap();

    toggleModal({
      name,
      id: agreeCd,
      type: 'content',
      data: termsData,
    });
  };

  function Section({ num, children }: { num: number; children: ReactNode }) {
    return (
      <div className={cx('section', `n${num}`)}>
        <div className={cx('inner')}>{children}</div>
      </div>
    );
  }

  return (
    <div className={cx('wrap')}>
      <div className={cx('landing')}>
        <div className={cx('logo_wrap')}>
          <div className={cx('inner')}>
            <div>
              <img src={logo} width="100%" alt="selpub" />
            </div>
            <div>
              {navList.map((name, i) => (
                <button
                  key={name}
                  onClick={() =>
                    scrollToRef?.current[i && i + 2]?.scrollIntoView()
                  }
                >
                  <span>{name}</span>
                </button>
              ))}
            </div>
            <div>
              <Link to={loginUrl}>
                <span>{LOGIN}</span>
              </Link>
            </div>
          </div>
        </div>

        <Section num={1}>
          <Link to={loginUrl}>
            <img src={isMobile ? m_section_01 : section_01} width="500" />
          </Link>
        </Section>
        {sectionImgList.map((name, i) => {
          return (
            <Section key={name} num={i + 2}>
              <img
                src={isMobile ? mobileSectionImgList[i] : sectionImgList[i]}
                width="1450"
                ref={(el) => {
                  scrollToRef.current[i] = el;
                }}
              />
              {i === 6 && (
                <div className={cx('slide_area', 'animate')}>
                  <ul>
                    {[1, 2, 3, 4].map((n, i) => (
                      <li key={n}>
                        <img
                          src={
                            isMobile ? mobileSlideImgList[i] : slideImgList[i]
                          }
                          width="1400"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Section>
          );
        })}
        <Section num={9}>
          <Link to={loginUrl}>
            <div className={cx('outer')}></div>
          </Link>
        </Section>
      </div>

      <div className={cx('footer_wrap')} id="footer">
        <h2>
          <img
            src={isMobile ? m_footer_logo : footer_logo}
            alt="Selpub Cloud"
          />
        </h2>

        <div className={cx('foot_box')}>
          <div className={cx('info')}>
            <span>{COPYRIGHT_DESC}</span>
          </div>

          <div className={cx('cont_link')}>
            <ul>
              <li>
                <div
                  className={cx('btn')}
                  onClick={() => openModal('privacyPolicy')}
                >
                  {PRIVACY_POLICY}
                </div>
              </li>
              <li>
                <div className={cx('btn')} onClick={() => openModal('terms')}>
                  {TERMS}
                </div>
              </li>
            </ul>
          </div>

          <div className={cx('info')}>
            <span>{ADDRESS}</span>
            <span>{BUSINESS_REGISTRATION_NUMBER}</span>
            <span>{CEO}</span>
            <br />
            <span>{COPYRIGHT}</span>
          </div>
        </div>

        <div className={cx('family_box')}>
          <button className={cx('btn', 'open_family')}>Family Site</button>
          <div className={cx('family_link')}>
            {Object.entries(FOOTER_LINK).map(([key, value]) => (
              <a
                key={key}
                href={value}
                target="_blank"
                rel="noopener noreferrer"
              >
                {key}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
